import { useEffect, useRef } from "react"

export const useValueNullificationOnUnmount = ({ onChange, id, value }) => {
  const isPrepopulatedValue =
    value &&
    typeof value === "object" &&
    Object.keys(value).length === 1 &&
    value.country_code

  const hadValueOnMount = useRef(
    value !== null &&
      value !== undefined &&
      value !== "" &&
      !isPrepopulatedValue,
  )

  // Track the version of this instance of the component
  const versionRef = useRef(0)

  useEffect(() => {
    versionRef.current++
    const localVersion = versionRef.current
    const shouldClear = hadValueOnMount.current

    const cleanup = () => {
      // only clear if no newer version of the component has been mounted
      if (versionRef.current === localVersion && shouldClear) {
        onChange(null, id)
      }
    }

    const timeout = setTimeout(cleanup, 0)

    // just in case the component unmounts before the timeout
    return () => clearTimeout(timeout)
  }, [onChange, id, value])
}
